import { styled } from 'styled-components';

import { listingRichTextStyles } from './listingRichTextStyles';

export const ListingRichTextHolder = styled.div<{
  $bodyText: string;
  $headlineText: string;
}>`
  overflow-wrap: anywhere;
  ${listingRichTextStyles};

  .ql-picker {
    &.ql-header {
      .ql-picker-label {
        &::before {
          content: '${(props) => props.$bodyText}';
        }

        &[data-value='4']::before {
          content: '${(props) => props.$headlineText}';
        }
      }

      .ql-picker-item {
        &::before {
          font-size: 1em;
          content: '${(props) => props.$bodyText}';
        }
        &[data-value='4']::before {
          content: '${(props) => props.$headlineText}';
        }
      }
    }
  }
`;
